import { render, staticRenderFns } from "./IconTooltip.vue?vue&type=template&id=634e71f6&scoped=true"
import script from "./IconTooltip.vue?vue&type=script&lang=js"
export * from "./IconTooltip.vue?vue&type=script&lang=js"
import style0 from "./IconTooltip.vue?vue&type=style&index=0&id=634e71f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634e71f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634e71f6')) {
      api.createRecord('634e71f6', component.options)
    } else {
      api.reload('634e71f6', component.options)
    }
    module.hot.accept("./IconTooltip.vue?vue&type=template&id=634e71f6&scoped=true", function () {
      api.rerender('634e71f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/buttons/IconTooltip.vue"
export default component.exports